import {
  getStateCurrentValue,
  getStateIsFilterActive,
  type State,
  type StateByFilterId,
} from 'app/common/ui-components/filter'

import { filterId } from './filterId'

export const filterActive = (state: State): boolean => {
  return getStateIsFilterActive(filterId, state)
}

export const byNonSpecialSelected = (state: State): boolean => {
  const [groupBy] = getStateCurrentValue(filterId, state) || []
  return groupBy === 'none'
}

export const byGroupComplexesSpecialSelected = (state: State): boolean => {
  const [groupBy] = getStateCurrentValue(filterId, state) || []
  return groupBy === 'by_group_complexes'
}

export const byCampComplexesSpecialSelected = (state: State): boolean => {
  const [groupBy] = getStateCurrentValue(filterId, state) || []
  return groupBy === 'by_camp_complexes'
}

export const byAnyComplexesNotSelected = (state: State): boolean => {
  const [groupBy] = getStateCurrentValue(filterId, state) || []
  return groupBy !== 'by_group_complexes' && groupBy !== 'by_camp_complexes'
}

export const byGroupComplexesSpecialApplied = (applied: StateByFilterId | null): boolean => {
  if (applied && applied[filterId]) {
    return applied[filterId].includes('by_group_complexes')
  }
  return false
}

export const byCampComplexesSpecialApplied = (applied: StateByFilterId | null): boolean => {
  if (applied && applied[filterId]) {
    return applied[filterId].includes('by_camp_complexes')
  }
  return false
}

export const byPaymentMethodApplied = (applied: StateByFilterId | null): boolean => {
  if (applied && applied[filterId]) {
    return applied[filterId].includes('by_payment_method')
  }
  return false
}

export const byPaymentMethodSelected = (state: State): boolean => {
  const [groupBy] = getStateCurrentValue(filterId, state) || []
  return groupBy === 'by_payment_method'
}

export const byItemsAndComplexesAndCostApplied = (applied: StateByFilterId | null): boolean => {
  if (applied && applied[filterId]) {
    return applied[filterId].includes('by_items_and_complexes_and_cost')
  }
  return false
}

export const byItemsAndComplexesAndCostSelected = (state: State): boolean => {
  const [groupBy] = getStateCurrentValue(filterId, state) || []
  return groupBy === 'by_items_and_complexes_and_cost'
}
